































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "KanbanCard",
})
export default class KanbanCard extends Vue {
  @Prop({ required: true }) item!: any;
  @Prop({ default: "#519DE1" }) color!: string;
  @Prop({ default: true }) showActions!: boolean;

  getInitials(name: string): string {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  }

  formatDate(date: string | Date): string {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}`;
  }

  getPriorityColor(priority: string): string {
    const colors: any = {
      high: "error",
      medium: "warning",
      low: "success",
    };
    return colors[priority.toLowerCase()] || "grey";
  }
}
